import { Button } from '@fagmobler/ui';
import { ServerProduct } from '@/lib/janitsjar/Product';
import { useAddItemToCart, useCart, useUpdateCart } from '@/components/cart';
import { useNavigation } from '@/contexts/navigation';
import { useStores } from '@/components/store';
import {
  convertLineitemIntoEcommerceObject,
  trackEvent,
} from '@/lib/analytics';
import {
  ALGOLIA_APPLICATION_ID,
  ALGOLIA_INDEX_NAME,
  ALGOLIA_SEARCH_API_KEY,
} from '@/lib/algolia/searchClient';
import { InsightsClient } from 'instantsearch.js';
import type { FagmoblerAlgoliaProduct } from '@fagmobler/types';
import { useCurrentStoreStock } from '@/cataloguePages/productPageWithVariants/helpers';
import { useSearchParams } from 'next/navigation';

declare global {
  interface Window {
    aa: InsightsClient;
  }
}

type AddToCartButtonProps = {
  product: ServerProduct;
  algoliaProduct: FagmoblerAlgoliaProduct;
};

export default function AddToCartButton({
  product,
  algoliaProduct,
}: AddToCartButtonProps) {
  const currentStoreStock = useCurrentStoreStock(product.stock ?? []);
  const addToCart = useAddItemToCart();
  const updateCart = useUpdateCart();
  const { setShowCart } = useNavigation();
  const searchParams = useSearchParams();
  const { cart } = useCart();

  const { current } = useStores();
  const currentStore = current.data?.store || undefined;

  const handleAddToCart = async () => {
    const line = {
      code: product.sku,
      quantity: 1,
    };

    setShowCart(true);

    if (!cart.data?.products || cart.data.products.length === 0) {
      await updateCart.mutate({ isMember: true });
    }

    await addToCart.mutate(line);

    trackEvent(
      'add_to_cart',
      convertLineitemIntoEcommerceObject({
        lineItem: line,
        product,
        algoliaProduct,
      }),
      currentStore
    );

    const queryID = searchParams?.get('queryID') as string;

    if (queryID && window.aa) {
      window.aa('convertedObjectIDsAfterSearch', {
        index: ALGOLIA_INDEX_NAME,
        eventName: 'Add to cart',
        queryID,
        objectIDs: [algoliaProduct.objectID],
      });
    } else {
      if (ALGOLIA_APPLICATION_ID && ALGOLIA_SEARCH_API_KEY && window.aa) {
        window.aa('init', {
          appId: ALGOLIA_APPLICATION_ID,
          apiKey: ALGOLIA_SEARCH_API_KEY,
        });
        window.aa('convertedObjectIDs', {
          index: ALGOLIA_INDEX_NAME,
          eventName: 'Add to cart',
          objectIDs: [algoliaProduct.objectID],
        });
      } else {
        console.error('no window.aa');
      }
    }
  };
  return (
    <Button
      className="flex gap-4 content-center py-3.5"
      disabled={
        !currentStoreStock?.availableToOrder && !currentStoreStock?.stock
      }
      onClick={handleAddToCart}
    >
      <div className="w-full max-w-48 mx-auto">
        <span className="cap-sm font-bold">Legg i handlekurv</span>
      </div>
    </Button>
  );
}
